import React from 'react';
import GymList from '../components/gym/GymList';
import { getGymsNotAffiliate } from '../view/HTTPService';

/**
 * /gymsnotaffiliate - Dojos NÃO afiliados.
 */
export default function GymsNotAffiliatePage() {
    return (
        <GymList
            titleKey="msg.jkaGymsNotAffiliate"
            fetchGyms={getGymsNotAffiliate}
        />
    );
}
